import { cn } from "@web/lib/utils"

/** responsive: 32px on mobile, 36px from md (shell header). lg: 64px (auth pages). */
type Size = "responsive" | "lg"

const mark: Record<Size, { box: string; letter: string; dot: string }> = {
  responsive: {
    box: "size-8 border-[1.5px] md:size-9 md:border-[1.6px]",
    letter: "-mt-1 text-[20px] md:text-[23px]",
    dot: "top-0 right-0 size-[7px] shadow-[0_0_0_2px_#fff] md:size-2",
  },
  lg: {
    box: "size-16 border-[1.8px]",
    letter: "-mt-[7px] text-[40px]",
    dot: "top-px right-px size-3 shadow-[0_0_0_3px_#fff]",
  },
}

export function BrandMark({ size = "responsive", className }: { size?: Size; className?: string }) {
  const s = mark[size]
  return (
    <span
      className={cn(
        "relative flex shrink-0 items-center justify-center rounded-full border-foreground",
        s.box,
        className,
      )}
    >
      <span className={cn("font-heading italic leading-none", s.letter)}>а</span>
      <span className={cn("absolute rounded-full bg-signal", s.dot)} />
    </span>
  )
}

export function BrandLogo({ size = "responsive", className }: { size?: Size; className?: string }) {
  const lg = size === "lg"
  return (
    <span className={cn("flex items-center", lg ? "gap-[18px]" : "gap-2.5 md:gap-3", className)}>
      <BrandMark size={size} />
      <span className={cn("flex flex-col", lg ? "gap-1" : "gap-0.5 md:gap-[3px]")}>
        <span
          className={cn(
            "font-heading italic",
            lg ? "text-5xl leading-[0.95]" : "text-[22px] leading-[0.9] md:text-[26px]",
          )}
        >
          ассистент
        </span>
        <span
          className={cn(
            "font-semibold uppercase leading-none text-muted-foreground",
            lg ? "text-[10px] tracking-[0.34em]" : "text-[8px] tracking-[0.3em] md:text-[9px]",
          )}
        >
          Dobraw
        </span>
      </span>
    </span>
  )
}

export function BrandLogoVertical({ className }: { className?: string }) {
  return (
    <span className={cn("flex flex-col items-center gap-3.5", className)}>
      <BrandMark size="lg" />
      <span className="flex flex-col items-center gap-1.5">
        <span className="font-heading text-[34px] italic leading-[0.9]">ассистент</span>
        <span className="text-[9px] font-semibold uppercase leading-none tracking-[0.34em] text-muted-foreground">
          Dobraw
        </span>
      </span>
    </span>
  )
}
